import { Grid2 as Grid } from "@mui/material";
import { useTranslate } from "@refinedev/core";

import { DiscountsAutocomplete, UsersAutocomplete,  Form } from "@shared/components";

export function CodeForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <DiscountsAutocomplete
          name="discount"
          label={translate("limited_code_admin.fields.discount")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="code"
          label={translate("limited_code_admin.fields.code")}
          instructions={translate("limited_code_admin.instructions.code")}
          multiline
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Switch
          name="used"
          label={translate("limited_code_admin.fields.used")}
          disabled
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <UsersAutocomplete
          name="reserved_for"
          label={translate("limited_code_admin.fields.reserved_for")}
          disabled
        />
      </Grid>
    </Grid>
  )
}
